import {FC} from 'react';

import {Typography} from '@mui/material';

import {BasketProductImage} from 'components/basket-product-image/BasketProductImage';
import {BasketLineItem} from 'types';
import {
  BasketCardContent,
  ProductItemUnavailableDiv,
  QuantityWrapper,
  StyledCard,
  StyledCardContentWrapper,
  StyledTitleTypography,
  StyledTitleTypographyWrapper
} from 'views/basket-product/styles';
import DiscountPriceBox from 'views/discount-price-box/DiscountPriceBox';

export type ProductItemProps = {
  isProductUnavailable: boolean;
  productUnavailableText: string;
  title: string;
  coverImageURL: string;
  originPrice: number;
  displayPrice: number;
  priceUnit: string;
  quantity: number;
  weight: string;
  productURL: string;
  maxQuantity: number;
  basketItem: BasketLineItem;
  promotedPrice?: number;
};

export const ProductItem: FC<ProductItemProps> = (props) => {
  const {
    coverImageURL,
    title,
    productURL,
    weight,
    originPrice,
    promotedPrice,
    displayPrice,
    priceUnit,
    productUnavailableText,
    basketItem
  } = props;

  return (
    <>
      <StyledCard>
        <StyledCardContentWrapper>
          <BasketProductImage src={coverImageURL} isBulky={basketItem.productDetails.isBulky} />
          <BasketCardContent>
            <StyledTitleTypographyWrapper href={productURL || '/'}>
              <StyledTitleTypography color="secondary" gutterBottom variant="body1" component="p" overflow={'clip'}>
                <b>{title}</b>
              </StyledTitleTypography>
            </StyledTitleTypographyWrapper>

            <Typography display={'block'} variant="caption" color="text.secondary">
              {weight}
            </Typography>
            <DiscountPriceBox
              originPrice={originPrice}
              priceUnit={priceUnit}
              displayPrice={promotedPrice ? promotedPrice : displayPrice}
            />
          </BasketCardContent>
          <QuantityWrapper>
            <ProductItemUnavailableDiv>{productUnavailableText}</ProductItemUnavailableDiv>
          </QuantityWrapper>
        </StyledCardContentWrapper>
      </StyledCard>
    </>
  );
};

export default ProductItem;
